var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _path19, _path20, _path21, _g4, _line, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g5, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _line2, _path58, _line3, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 320.17",
    style: {
      enableBackground: "new 0 0 750 320.17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{display:none;fill:#2F1829;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{opacity:0.45;fill:url(#SVGID_00000084498647122371128750000005820119470837203084_);}\n\t.st5{fill:url(#SVGID_00000147201566456414394330000009404996852682360196_);}\n\t.st6{fill:url(#SVGID_00000111169275459372518190000003477331470978179726_);}\n\t.st7{fill:#2F1829;}\n\t.st8{opacity:0.25;fill:#FFFFFF;}\n\t.st9{fill:url(#SVGID_00000096760810834723484020000010897531729821677193_);}\n\t.st10{fill:url(#SVGID_00000003793741845816953840000003416412856506068370_);}\n\t.st11{fill:#F3475C;}\n\t.st12{opacity:0.25;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:#FFCA51;}\n\t.st15{fill:#982245;}\n\t.st16{fill:url(#SVGID_00000171701012885307781320000001440287318793986728_);}\n\t.st17{fill:url(#SVGID_00000079467684136937935550000006761018108010651067_);}\n\t.st18{fill:url(#SVGID_00000040567330302836449510000015231680756912098480_);}\n\t.st19{fill:url(#SVGID_00000089546300359447073210000011763482516668869564_);}\n\t.st20{fill:url(#SVGID_00000176035535039878337270000010961752510261799073_);}\n\t.st21{fill:url(#SVGID_00000155833438587347962520000004160260450823303344_);}\n\t.st22{fill:url(#SVGID_00000021083838495624268900000006020107228431835580_);}\n\t.st23{fill:url(#SVGID_00000165943401804691970910000000415425694516851621_);}\n\t.st24{fill:#2F172B;}\n\t.st25{fill:url(#SVGID_00000054978782259835529710000017330908328444578454_);}\n\t\n\t\t.st26{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4635;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{fill:none;stroke:#FFFFFF;stroke-width:0.4635;stroke-linecap:round;stroke-linejoin:round;}\n\t.st28{fill:none;stroke:#FFFFFF;stroke-width:0.4635;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.3555,1.3555;}\n\t\n\t\t.st29{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4635;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:1.3906;}\n\t.st30{fill:#4C3146;}\n\t.st31{fill:#1F3247;}\n\t.st32{fill:url(#SVGID_00000137834303266743452580000017547232909165504934_);}\n\t.st33{fill:#122230;}\n\t.st34{fill:url(#SVGID_00000181053883789839400500000016929500481671195043_);}\n\t.st35{fill:url(#SVGID_00000033337935006072549360000002327593939024153508_);}\n\t.st36{fill:#F5B539;}\n\t.st37{fill:url(#SVGID_00000114786229195732010100000009691702698807402665_);}\n\t.st38{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4635;stroke-miterlimit:10;}\n\t.st39{fill:none;stroke:#1F3247;stroke-width:0.9271;stroke-miterlimit:10;}\n\t.st40{fill:#FFADAE;}\n\t.st41{display:inline;}\n\t.st42{fill:#1D262D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -52.43,
    className: "st1",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.4,303.98c0,0,11.23,19.9,92.03,28.96c80.8,9.06,121.58,39.27,172.93,48.33 c51.35,9.06,114.78-50.6,169.91-41.53c55.13,9.06,121.58-25.46,126.87-35.76H128.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.9359,
    y1: 298.6303,
    x2: 389.9567,
    y2: 66.0411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8D197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEF5DA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M711.85,300.03h-11.94l-526.32,0.1c0,0-5.32-4.2-13.61-11.41c-3.56-3.09-7.66-6.74-12.13-10.85 c-1.62-1.49-3.29-3.04-5-4.65c-15.68-14.75-34.64-34.23-50.04-54.98c-16.23-21.85-28.52-45.1-28.86-65.7 c-0.01-0.46-0.02-0.92-0.01-1.38c0.18-19.94,4.1-41.43,13.81-61.38C83.4,78.12,91.03,67,101.05,57.02 c26.11-26.01,68.35-44.23,133.92-43.7c76.46,0.61,155.76,29.12,227.36,68.55c0,0,0,0,0.01,0c14.98,8.25,29.62,16.98,43.83,26.03 c10.51,6.69,20.78,13.56,30.78,20.55c27.82,19.44,53.5,39.76,76.2,59.6C664.69,233.1,700.86,275.7,711.85,300.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084503689913296474010000016430369504259126718_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.2327,
    y1: 181.4317,
    x2: 390.1971,
    y2: 289.0416
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000084503689913296474010000016430369504259126718_)"
    },
    d: "M711.85,300.03h-11.94 l-526.32,0.1c0,0-5.32-4.2-13.61-11.41c-3.56-3.09-7.66-6.74-12.13-10.85c-1.62-1.49-3.29-3.04-5-4.65 c-15.68-14.75-34.64-34.23-50.04-54.98c-16.23-21.85-28.52-45.1-28.86-65.7c6.54-3.47,21.86-10.42,34.54-7.25 c16.62,4.15,20.16,23.89,20.16,23.89s11.9-9.59,24.38-5.04c12.48,4.56,14.36,17.77,14.36,17.77s14.7-7.58,27.93-4.35 c13.23,3.23,23.85,16.05,9.67,24.36c-14.01,8.21-29.88,1.87-30.25,1.73c0.19,0.25,5.76,7.72-4.33,16.92 c-10.27,9.35,29.1,17.46,29.1,17.46s1.48-25.65,27.92-22.75c26.44,2.89,47.75,17.17,47.75,17.17s1.33-39.19,22.48-46.37 c21.14-7.18,32.02,15.85,32.02,15.85s46.83-30.33,62.75-2.06c15.93,28.27,16.56,33.62,16.56,33.62s13.55-74.23,56.08-70.83 c42.53,3.4,50.42,32.89,49.68,35.89c-0.74,3,12.21-19.06,24.99-7.09c12.78,11.98,20.2,28.69,20.2,28.69l67.29-7.94 c0,0-6.85-13.27-4.07-24.16C664.69,233.1,700.86,275.7,711.85,300.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156588061885234224830000013644569415652770956_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.0865,
    y1: 85.7374,
    x2: 406.8416,
    y2: 112.168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156588061885234224830000013644569415652770956_)"
    },
    d: "M506.17,107.9H307.27 c24.92,0,29.83-9.06,44.56-13.97c0.71-0.23,1.41-0.44,2.1-0.61c13.78-3.49,25.15,4.36,33.96,4c9.25-0.38,19.44-10.2,30.02-13.59 c3.59-1.15,7.31-0.78,11.12,0.12c7.43,1.76,15.22,5.54,23.13,4.04c6.89-1.3,7.4-4.09,10.17-6.02c0,0,0,0,0.01,0 C477.32,90.12,491.96,98.85,506.17,107.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094598761513727403100000001122569778391789969_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.3367,
    y1: 42.2856,
    x2: 163.6022,
    y2: 100.433
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094598761513727403100000001122569778391789969_)"
    },
    d: "M248.65,89.78H77.73 c5.58-11.47,13.07-22.44,22.85-32.29c0.15-0.15,0.31-0.31,0.47-0.47c4.05-0.83,8.4-1.41,12.98-1.6 c27.11-1.13,32.84,19.26,32.84,19.26s7.1-9.44,19.94-4.91c12.84,4.53,8.31,10.2,18.5,13.22c1.32,0.39,2.72,0.49,4.17,0.36 c9.72-0.84,21.99-11.48,32.83-7.53C234.78,80.34,226.64,89.78,248.65,89.78z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M734.61,307.83H98.93c-2.13,0-3.86-1.73-3.86-3.86l0,0c0-2.13,1.73-3.86,3.86-3.86h635.69 c2.13,0,3.86,1.73,3.86,3.86l0,0C738.47,306.11,736.74,307.83,734.61,307.83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M429.03,83.86c-11.33,2.9-24.11,15.21-32.39,17c-10.45,2.26-22.53-3.02-34.23-5.97 c-3.55-0.9-6.33-1.36-8.47-1.56c13.78-3.49,25.15,4.36,33.96,4c9.25-0.38,19.44-10.2,30.02-13.59 C421.49,82.58,425.21,82.96,429.03,83.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.49,83.34c-10.2,5.33-14.92-6.8-23.81-10.77c-10.19-4.56-17.37,9.66-20.39,7.2 c-3.02-2.45-4.34-13.02-15.86-18.5c-6.54-3.1-19.16-3.78-28.85-3.78c0.15-0.15,0.31-0.31,0.47-0.47c4.05-0.83,8.4-1.41,12.98-1.6 c27.11-1.13,32.84,19.26,32.84,19.26s7.1-9.44,19.94-4.91c12.84,4.53,8.31,10.2,18.5,13.22 C186.64,83.37,188.04,83.47,189.49,83.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171720524846196706900000005257796824482590885_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.4343,
    y1: 274.3421,
    x2: 508.514,
    y2: 59.6875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8D197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEF5DA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171720524846196706900000005257796824482590885_)"
    },
    d: "M463.94,58.54 c0,0,71.36,63.72,99.68,55.03C591.94,104.88,414.01,20.64,463.94,58.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119819849572696579090000012563054776357206198_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.3238,
    y1: 504.3061,
    x2: 39.325,
    y2: 142.543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8D197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEF5DA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119819849572696579090000012563054776357206198_)"
    },
    d: "M52.72,123.3 c0,0-24.32,42.71,18.12,87.75c9.82,10.42,10.95,29.78-8.68,30.86c-19.63,1.08-50.22-46.87-49.09-85.39 C14.21,118.01,59.24,100.58,52.72,123.3z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M539.42,350.31c0,0-41.09,9.06-51.66,23.03c-5.17,6.84,15.36,5.81,32.83-1.7 C538.82,363.81,553.85,349.35,539.42,350.31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.39,347.67c0,0,16-0.38,30.09,5.1c14.09,5.47,17.11,22.28,3.14,24.35 c-13.97,2.08-45.79-16.54-43.99-24.17C231.95,347.35,241.39,347.67,241.39,347.67z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.41,256.57l-9.04,31.34c-3.56-3.09-7.66-6.74-12.13-10.85l-1.96-3.65c0,0,3.44-40.19-7.92-56.28 c10.87,7.6,16.07,38,16.07,38l-1.69,2.26h1.69c0,0,2.7,5.15,3.74,12.73c6.96-36.16,0.2-53.63,0.01-54.11 c0.27,0.32,5.68,7.01,8.92,17.9c3.33,11.17,2.08,18.2,2.08,18.2l-2.7,4.47H168.41z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M442.42,287.4c0,0,2.95-2.64,5.13-5.47c0.39-0.5,0.74-1.01,1.06-1.51l1.34,1.63l-0.46-2.57 c0,0,9.21-3.23,12.53-12.1c-2.02,9.77-5.92,17-10.51,20.37c-2.01,1.48-4.14,2.21-6.32,2.09 C438.07,289.48,442.42,287.4,442.42,287.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M462.02,267.39c-2.9,8.82-8.94,22.57-19.9,22.28c-0.3-0.02-0.28-0.49,0.03-0.46 C452.89,289.63,459.03,276.02,462.02,267.39L462.02,267.39z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M442.42,287.4c0,0,2.95-2.64,5.13-5.47c0.92,2.72,2.82,4.78,3.96,5.83c-2.01,1.48-4.14,2.21-6.32,2.09 C438.07,289.48,442.42,287.4,442.42,287.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.86,269.74c0,0-21.28-19.94-17.84-46.63c2.19,12.36,11.18,27.1,11.18,27.1l-1.12,3.33l3.99-0.78 c0,0,5.04-30.45-6.3-45.11c15.29,15.75,15.11,39.2,15.11,39.2l-2.88,4.32l2.88,1.26c0,0-3.35,11.38,6.6,7.01 c9.95-4.37,16.25-42.17,7.25-51.78c10.79,9.27,9,41.13,9,42.2c0,1.07-4.68,5.34-4.68,5.34l3.6,2.58 C397.67,257.79,395.41,279.36,370.86,269.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.35,298.13c0,0-7.39-6.93-6.2-16.2c0.76,4.29,3.88,9.42,3.88,9.42l-0.39,1.16l1.39-0.27c0,0,1.75-10.58-2.19-15.67 c5.31,5.47,5.25,13.62,5.25,13.62l-1,1.5l1,0.44c0,0-1.16,3.95,2.29,2.43c3.46-1.52,5.65-14.65,2.52-17.99 c3.75,3.22,3.13,14.29,3.13,14.66s-1.63,1.85-1.63,1.85l1.25,0.89C477.66,293.97,476.88,301.47,468.35,298.13z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M440.08,287.95l-6.01,0.42c4.34-3.89,3.69-7.62,3.04-9.33c-0.23-0.62-0.47-0.97-0.47-0.97l2.83-0.46 l-1.59-2.16c0,0,5.14-5.94,7.07-21.76c6.08,10.66,3.7,20.25,0.5,26.55C443.01,285.05,440.08,287.95,440.08,287.95z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M444.96,253.68c2.29,11.51,2.07,25.12-6.26,34.25c-0.2,0.23-0.56-0.1-0.33-0.32 C446.73,278.65,447.08,265.13,444.96,253.68L444.96,253.68z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M440.08,287.95l-6.01,0.42c4.34-3.89,3.69-7.62,3.04-9.33c3.15,1.95,6.39,1.67,8.35,1.19 C443.01,285.05,440.08,287.95,440.08,287.95z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M479.24,299.32h-97.42l15.61-12.67c0,0,20.79-10.69,29.46-8.46c8.68,2.22,7.29,9.52,7.29,9.52 s0.52-0.58,1.41-1.27c1.93-1.5,5.58-3.54,9.29-1.33c5.28,3.15,4.45,7.3,4.41,7.5c0.17-0.17,3.34-3.24,5.91-2.26 c2.64,1.01,3.67,3.9,3.67,3.9s3.37-4.74,6.27-3c2.89,1.74,4.53,5.26,4.53,5.26S474.33,291.93,479.24,299.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M460.44,299.32h-78.62l15.61-12.67c0,0,20.79-10.69,29.46-8.46c8.68,2.22,7.29,9.52,7.29,9.52 s0.52-0.58,1.41-1.27c0.18,1.57,0.21,3.21-0.02,4.81c0,0,4.4-1.66,7.3,0.73c2.89,2.39,2.01,4.53,2.01,4.53s3.9-2.27,8.31,0 C454.69,297.29,457.45,298.32,460.44,299.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000201755626829467150000006589420826401693848_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.1317,
    y1: 289.7916,
    x2: 236.6213,
    y2: 182.0543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F1829"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B223C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000201755626829467150000006589420826401693848_)"
    },
    d: "M283.87,230.75V123.84h-40.62v0.37 l-48.88,78.63l-21.39,34.41l2.41,24.83h67.85v37.24h40.62v-37.24h17.83v-31.33H283.87z M243.26,230.75h-31.57l29.04-49.9 l2.53-4.09V230.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158734629802933447360000002262461852978127534_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.3322,
    y1: 287.784,
    x2: 379.8217,
    y2: 180.0474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F1829"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B223C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158734629802933447360000002262461852978127534_)"
    },
    d: "M425.36,138.43 c-10.68-12.94-25.75-19.41-45.2-19.41s-34.49,6.43-45.13,19.28c-10.65,12.85-15.97,31.13-15.97,54.84v32.06 c0,23.54,5.34,41.78,16.03,54.72c10.69,12.93,25.79,19.4,45.32,19.4c19.36,0,34.37-6.42,45.02-19.28 c10.65-12.85,15.97-31.13,15.97-54.84v-31.94C441.4,169.64,436.05,151.36,425.36,138.43z M359.8,185.31 c0.24-11.73,1.95-20.49,5.12-26.27c3.17-5.79,8.26-8.68,15.24-8.68c7.15,0,12.37,3.11,15.67,9.34c3.29,6.23,4.94,15.65,4.94,28.26 v43.38c-0.08,12.62-1.76,21.87-5.06,27.78c-3.29,5.91-8.4,8.86-15.31,8.86c-7.15,0-12.37-3.03-15.67-9.1 c-3.11-5.72-4.75-14.57-4.93-26.55c-0.01-0.72-0.02-1.46-0.02-2.2V185.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065765570385756075490000008288750032205412244_",
    gradientUnits: "userSpaceOnUse",
    x1: 523.9547,
    y1: 285.7846,
    x2: 522.4443,
    y2: 178.0485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F1829"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B223C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065765570385756075490000008288750032205412244_)"
    },
    d: "M569.75,230.75V123.84h-40.61v0.37 l-70.26,113.05l2.41,24.83h67.85v37.24h40.61v-37.24h17.84v-31.33H569.75z M529.13,230.75h-31.58l29.05-49.9l2.53-4.09V230.75z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M276.32,123.84c-5.43,6.95-24.07,4.47-28.26,4.91c-4.76,0.5-37.78,58.65-42.31,66.03 c-2.94,4.79-8.1,7.06-11.37,8.06l48.88-78.63v-0.37H276.32z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M569.75,123.84v80.95c-10.4-8.63-4.67-72.42-6.31-74.53c-1.76-2.26-23.41-0.75-27.44-2.01 c-2.67-0.84-4.83-3.03-5.97-4.41H569.75z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M388.74,278.02c-32.72,1.51-28.94-45.66-28.94-45.66l0.02-0.02c0.17,11.98,1.82,20.83,4.93,26.55 c3.29,6.06,8.52,9.1,15.67,9.1c6.91,0,12.01-2.96,15.31-8.86c3.29-5.91,4.98-15.16,5.06-27.78v-43.38 c0-12.62-1.65-22.03-4.94-28.26c-3.3-6.23-8.52-9.34-15.67-9.34c0,0,20.25-2.47,28.51,27.48 C416.94,207.79,421.46,276.51,388.74,278.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129175599650487266420000013066234241084726198_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.8349,
    y1: 96.3044,
    x2: 346.6726,
    y2: 137.083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F1829"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B223C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129175599650487266420000013066234241084726198_)"
    },
    d: "M345.7,138.29c0,0-13.59-9.82-15.1-25.17 c9.82,2.77,15.1,14.69,15.1,14.69s-2.52-10.94,0-18.41C353,119.92,350.98,128.47,345.7,138.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096017144898083442230000010321042829538041002_",
    gradientUnits: "userSpaceOnUse",
    x1: 670.074,
    y1: 282.7157,
    x2: 489.5927,
    y2: 156.6055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096017144898083442230000010321042829538041002_)"
    },
    d: "M617.23,227.19c0,0,0.06,0.32-0.39,0.78 c-0.32,0.33-0.9,0.73-1.95,1.13c-6.21,2.37-18.89-3.38-25.78-7.26c-6.9-3.89-26.55-0.69-39.78-2.49 c-13.23-1.8-18.84-8.97-30.74-11.89c-11.9-2.92-56.27,9.86-58.73-0.08c-2.46-9.94,47.35-106.69,51.62-99.94 c4.26,6.75,19.02,7.19,29.36,12.52c10.35,5.32,19.22,32,30.72,34.66c1.58,0.37,3.11,0.96,4.57,1.74 c9.18,4.89,15.76,17.18,16,27.24c0.28,11.66,16.21,21.08,22.04,27.35C619.99,217.22,617.23,227.19,617.23,227.19z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M617.23,227.19c0,0,0.06,0.32-0.39,0.78c2.06-12.75-9.74-18.81-20.54-27.8c-11.12-9.25-6.44-16.23-8.72-25.67 c-1.35-5.58-7.03-13-11.46-18.14c9.18,4.89,15.76,17.18,16,27.24c0.28,11.66,16.21,21.08,22.04,27.35 C619.99,217.22,617.23,227.19,617.23,227.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109739274359702911590000014304785895750500006_",
    gradientUnits: "userSpaceOnUse",
    x1: 660.8715,
    y1: 294.3912,
    x2: 660.7141,
    y2: 285.5809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D17878"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109739274359702911590000014304785895750500006_)"
    },
    d: "M663.87,288.28v3.77 c-0.66-0.06-2.28,0.05-3.71,0.19c-0.88,0.08-1.69,0.17-2.16,0.22l-0.34-3.2l1.48-0.23L663.87,288.28z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M616.99,225.51l-2.95,2.69c-0.42,0.38-0.27,1.08,0.27,1.25l2.49,0.79l5.76,6.31 c0.26,0.28,0.69,0.3,0.97,0.04l0.95-0.86c0.28-0.26,0.3-0.69,0.04-0.97l-5.76-6.31l-0.56-2.56 C618.08,225.34,617.41,225.12,616.99,225.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124154034039340378810000014920219346694525848_",
    gradientUnits: "userSpaceOnUse",
    x1: 617.9591,
    y1: 241.3304,
    x2: 646.0258,
    y2: 214.6482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D17878"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124154034039340378810000014920219346694525848_)"
    },
    d: "M639.65,229.52 c-0.75,0.99-1.74,2.27-2.75,3.55c-0.38,0.48-0.77,0.96-1.14,1.42c-1.57,1.94-3.01,3.55-3.46,3.63c-1.13,0.19-7.51-3.45-8.45-3.45 c-0.94,0-3.07,1.56-3.63,1.41c-0.57-0.15-3.68-3.02-3.59-3.72c0.1-0.71,2.88-3.16,4.25-3.54c0.38-0.11,1.22,0.02,2.25,0.24 c0,0,0.06,0.02,0.16,0.04c2.67,0.59,6.53,1.8,7.13,1.49c0.3-0.15,0.93-1.15,1.62-2.38c0.24-0.44,0.49-0.9,0.73-1.37 c0.31-0.59,0.61-1.18,0.88-1.71c0.28-0.55,0.51-1.04,0.69-1.41c0.58,0.86,1.52,2.01,2.46,3.07 C637.95,228.12,639.12,229.27,639.65,229.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110464376601904488870000015008624304315351726_",
    gradientUnits: "userSpaceOnUse",
    x1: 662.4777,
    y1: 251.7086,
    x2: 662.8553,
    y2: 221.2514
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D17878"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110464376601904488870000015008624304315351726_)"
    },
    d: "M665.61,237.03 c0.01,2.08-0.04,4.08-0.16,5.7c-0.5,6.46-1.01,11.75-3.21,11.87c-2.2,0.12-2.64-17.49-2.52-18.56c0.03-0.21,0.04-0.65,0.06-1.23 c0.06-1.92,0.07-5.35,0.11-6.83c0.01-0.37,0.02-0.62,0.03-0.69l0.41-0.26l4.81-3.07c0,0,0.28,4.17,0.41,8.92 c0.02,0.65,0.04,1.31,0.05,1.97C665.6,235.58,665.61,236.31,665.61,237.03z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M665.61,237.03c-1.12,0.97-2.92,2.22-4.76,2.26c-3.02,0.06,1.4-6.12,2.4-6.27c0.39-0.05,1.31-0.1,2.29-0.14 c0.02,0.65,0.04,1.31,0.05,1.97C665.6,235.58,665.61,236.31,665.61,237.03z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M665.59,234.86c-1.24,0.44-2.91,0.69-5.03,0.25c-0.3-0.06-0.56-0.16-0.78-0.29 c-1.85-1.04-1.1-4.09,0.11-6.83c0.14-0.32,0.29-0.64,0.43-0.95l4.81-3.07C665.13,223.97,665.49,229.35,665.59,234.86z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M655.38,200.02c-0.06,0.65-0.4,1.47-0.89,2.27c-0.61,1.03-1.47,2.04-2.28,2.71 c-0.63,0.51-1.24,0.82-1.71,0.75c-1.54-0.22-3.46-2.71-3.5-3.18c-0.03-0.47,1.65-0.65,1.44-2.04c-0.22-1.38-1.1-1.64-1.76-1.38 c-0.66,0.25-1.46,1.69-1.43,3.05c-0.44-0.06-1.28-1.73-2.83-2.69c-0.43-0.26-0.91-0.48-1.46-0.58c-0.68-0.13-1.46-0.1-2.36,0.21 c-0.41-5,2.61-7.2,4.94-6.32c0,0-0.85-1.66-2.08-2.01c2.83,0.41,3.52,2.8,3.52,2.8s0.79-3.37,4.38-3.81 c3.59-0.44,4.28,4.28,4.28,4.28s0.75-2.33,0.42-3.69c0.64,1.86-0.14,4.92-0.14,4.92s1.73,0.47,2.14,2.71 c-1.45-1.13-1.54-1.01-1.54-1.01S655.56,197.91,655.38,200.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106855218581638642490000008692743261935147686_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.8019,
    y1: 203.074,
    x2: 650.3151,
    y2: 204.4899
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D17878"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106855218581638642490000008692743261935147686_)"
    },
    d: "M652.21,205 c-0.28,0.78-0.55,1.52-0.67,1.78c-0.29,0.66-3.97,3.74-6.6,0.19c-2.21-2.99-2.49-6.44-2.52-7.47c1.55,0.95,2.38,2.63,2.83,2.69 c-0.03-1.36,0.77-2.8,1.43-3.05c0.66-0.25,1.54,0,1.76,1.38c0.22,1.39-1.46,1.57-1.44,2.04c0.03,0.47,1.95,2.96,3.5,3.18 C650.97,205.82,651.58,205.51,652.21,205z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M654.03,190.28c-0.07-0.19-0.16-0.36-0.26-0.51C653.89,189.9,653.98,190.08,654.03,190.28z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M666.77,223.34c-0.37,0.69-0.77,1.31-1.16,1.84c-0.12,0.17-0.25,0.33-0.37,0.49 c-1.13,1.41-2.12,2.13-2.12,2.13s0.01,0.04,0.02,0.13c0.02,0.11,0.05,0.27,0.09,0.49c0.08,0.51,0.21,1.31,0.35,2.26 c0.02,0.16,0.04,0.32,0.06,0.49c0.06,0.45,0.12,0.93,0.17,1.42c0.03,0.28,0.06,0.56,0.09,0.85c0.01,0.16,0.03,0.33,0.04,0.49 c0.06,0.77,0.11,1.54,0.11,2.27c0.01,0.16,0.01,0.33,0,0.49c-0.01,0.87-0.07,1.66-0.22,2.27c-0.04,0.18-0.1,0.34-0.15,0.49 c-0.07,0.18-0.15,0.33-0.25,0.46c-0.12,0.14-0.3,0.27-0.56,0.38c-1.66,0.75-6.09,0.78-10.46,0.55h-0.01 c-3.79-0.2-7.54-0.61-9.43-0.93c-0.56-0.1-1.01-0.25-1.37-0.46c-0.25-0.14-0.45-0.3-0.61-0.49c-0.11-0.11-0.19-0.22-0.26-0.34 c-0.34-0.53-0.46-1.19-0.44-1.93c0-0.16,0.01-0.32,0.03-0.49c0.06-0.67,0.21-1.4,0.39-2.15c0.01-0.04,0.02-0.08,0.03-0.12 c0.04-0.16,0.08-0.32,0.13-0.49c0.19-0.76,0.41-1.53,0.58-2.27c0.03-0.12,0.05-0.23,0.08-0.34c0.01-0.05,0.02-0.1,0.03-0.14 c0.19-0.91,0.32-1.66,0.4-2.26c0.03-0.17,0.04-0.34,0.06-0.49c0.15-1.44,0.02-1.89,0.02-1.89s-0.39,0.96-0.87,1.89 c-0.09,0.17-0.19,0.33-0.28,0.49c-0.36,0.62-0.75,1.12-1.05,1.14c-0.05,0.01-0.11-0.01-0.19-0.05c-0.29-0.13-0.77-0.54-1.33-1.1 c-0.15-0.15-0.32-0.32-0.49-0.49c-0.33-0.34-0.68-0.73-1.03-1.12c-0.33-0.37-0.66-0.76-0.97-1.14c-0.14-0.16-0.27-0.33-0.4-0.49 c-0.42-0.52-0.8-1.02-1.09-1.45c-0.22-0.32-0.39-0.6-0.49-0.82c-0.07-0.14-0.11-0.25-0.11-0.33c0-0.04,0-0.09,0.01-0.15 c0.06-0.38,0.32-1.2,0.74-2.27c0.06-0.15,0.13-0.32,0.2-0.49c0.28-0.69,0.62-1.46,1-2.27c0.08-0.16,0.16-0.32,0.24-0.49 c0.35-0.74,0.75-1.51,1.17-2.27c0.09-0.16,0.18-0.33,0.28-0.49c0.44-0.78,0.92-1.55,1.4-2.27c0.12-0.16,0.23-0.33,0.34-0.49 c0.63-0.88,1.29-1.66,1.94-2.26c0.2-0.18,0.4-0.35,0.59-0.49c0.11-0.08,0.22-0.16,0.33-0.23c0.9-0.57,1.81-1.01,2.69-1.35 c3.06-1.16,5.68-1.05,5.68-1.05c1.53,0,3.02,0.3,4.46,0.87c1.06,0.43,2.09,1.02,3.08,1.75c0.21,0.16,0.42,0.32,0.63,0.49 c0.79,0.66,1.55,1.41,2.28,2.26c0.14,0.16,0.28,0.32,0.4,0.49c0.56,0.7,1.1,1.45,1.61,2.27c0.1,0.16,0.2,0.32,0.3,0.49 c0.43,0.72,0.84,1.47,1.22,2.27c0.08,0.16,0.16,0.32,0.23,0.49c0.34,0.73,0.67,1.48,0.97,2.27c0.06,0.16,0.12,0.32,0.19,0.49 c0.27,0.73,0.53,1.48,0.77,2.27c0.05,0.15,0.1,0.31,0.14,0.47c0,0.01,0.01,0.02,0.01,0.02 C666.69,223.06,666.72,223.19,666.77,223.34z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M658.51,209.15h-17.46c0.2-0.18,0.4-0.35,0.59-0.49h16.24C658.09,208.81,658.3,208.98,658.51,209.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M661.19,211.9h-22.43c0.12-0.16,0.23-0.33,0.34-0.49h21.68C660.92,211.57,661.06,211.73,661.19,211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M663.1,214.65h-26.02c0.09-0.16,0.18-0.33,0.28-0.49h25.44C662.9,214.32,663,214.49,663.1,214.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M664.56,217.4h-28.88c0.08-0.16,0.16-0.32,0.24-0.49h28.41C664.4,217.08,664.48,217.24,664.56,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M665.72,220.16h-31.23c0.06-0.15,0.13-0.32,0.2-0.49h30.85C665.59,219.83,665.65,219.99,665.72,220.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M666.64,222.91h-32.8c-0.07-0.14-0.11-0.25-0.11-0.33c0-0.04,0-0.09,0.01-0.15h32.75 c0.05,0.15,0.1,0.31,0.14,0.47C666.63,222.9,666.64,222.91,666.64,222.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M665.61,225.18c-0.12,0.17-0.25,0.33-0.37,0.49h-29.42c-0.14-0.16-0.27-0.33-0.4-0.49H665.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M637.83,227.93h3.34c-0.09,0.17-0.19,0.33-0.28,0.49h-2.57C638.16,228.27,638,228.1,637.83,227.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M663.23,228.42h-21.27c0.03-0.17,0.04-0.34,0.06-0.49h21.12C663.16,228.04,663.19,228.2,663.23,228.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M663.64,231.17h-22.19c0.03-0.12,0.05-0.23,0.08-0.34c0.01-0.05,0.02-0.1,0.03-0.14h22.01 C663.6,230.84,663.62,231.01,663.64,231.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M663.94,233.92h-23.2c0.04-0.16,0.08-0.32,0.13-0.49h23.03C663.91,233.6,663.93,233.77,663.94,233.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M664.05,236.19c0.01,0.16,0.01,0.33,0,0.49h-23.76c0-0.16,0.01-0.32,0.03-0.49H664.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M663.84,238.95c-0.04,0.18-0.1,0.34-0.15,0.49h-22.07c-0.25-0.14-0.45-0.3-0.61-0.49H663.84z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M664.35,285.13c-1.04,0.66-8.02,1.41-8.02,1.41l-0.21-1.27l-1.29-7.61c0-0.01,0-0.02-0.01-0.03l-3.03-17.99 l-3.06,22.46l-0.9,6.61c0,0-8.59,0.47-8.59-1.6c0-0.25,0.02-1.18,0.06-2.61c0.25-9.17,1.21-39.14,1.44-45.9 c0.39,0.63,1.1,1.09,2.25,1.28c0.1,0.02,0.21,0.04,0.32,0.05c4.39,0.69,16.54,1.68,19.57,0.33c0.13,1.1,0.26,2.84,0.38,5.01 c0.47,8.73,0.82,24.4,0.98,33.27C664.3,282.52,664.35,285.13,664.35,285.13z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M654.82,277.64l-3.03-17.99c0,0,0.82-7.24,1.13-8.06c0.32-0.82,2.52-0.19,3.46-0.82 c0.5,1.2-2.64,2.71-2.9,6.48C653.31,259.97,654.27,271.43,654.82,277.64z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M642.43,242.51c0,0-0.28,4.11,3.07,6.09"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 643.14,
    y1: 248,
    x2: 643.11,
    y2: 248.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 643.04,
    y1: 250.05,
    x2: 641.41,
    y2: 284.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 641.38,
    y1: 285.26,
    x2: 641.34,
    y2: 285.95
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 654.87,
    y1: 251.91,
    x2: 657.89,
    y2: 284.25
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M657.43,243.16c0,0-0.34,3.95,0,4.71c0.34,0.76,1.82,1.4,2.14,1.56c0.32,0.16,1.75-1.1,1.82-1.93 c0.07-0.83,0.16-4.18,0.16-4.18S659.08,242.84,657.43,243.16z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M664.35,285.13c-1.04,0.66-8.02,1.41-8.02,1.41l-0.21-1.27c2.03-1.15,6.05-3.7,8.12-6.73 C664.3,282.52,664.35,285.13,664.35,285.13z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M664.76,288.14l-0.88,0.14l-6.21,0.97l-0.43,0.07c-0.91,0.14-1.76-0.48-1.91-1.39l-0.02-0.14 c-0.14-0.91,0.48-1.76,1.39-1.9l7.53-1.18c0.91-0.14,1.76,0.48,1.9,1.39l0.02,0.14C666.29,287.15,665.67,288,664.76,288.14z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M648.73,282.11l-0.9,6.61c0,0-8.59,0.47-8.59-1.6c0-0.25,0.02-1.18,0.06-2.61 C641.32,284.35,646,283.82,648.73,282.11z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M648.6,289.15l-0.02,0.14c-0.08,0.91-0.9,1.59-1.81,1.5l-0.05-0.01l-6.56-0.61l-0.98-0.09 c-0.92-0.08-1.59-0.9-1.51-1.81l0.02-0.14c0.08-0.92,0.9-1.59,1.81-1.5l7.59,0.7C648.01,287.42,648.68,288.23,648.6,289.15z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M663.25,245.28c-10.47,1.4-17.57-3.4-19.95-5.34c4.39,0.69,16.54,1.68,19.57,0.33 C663.01,241.37,663.13,243.11,663.25,245.28z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M641.53,230.83c0.82-3.78,0.5-4.78,0.5-4.78s-1.39,3.46-2.2,3.52c-0.38,0.03-1.72-1.27-3.04-2.76 c1.14-0.29,2.9-0.87,3.81-1.9c1.41-1.6,1.27-8.45,1.81-8.5c0.55-0.05,1.8,12.65-1.71,17.63 C640.97,232.98,641.31,231.88,641.53,230.83z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M666.77,223.34c-1.57,2.96-3.65,4.46-3.65,4.46s-1.86-9.8-2.42-10.76c-0.44-0.76,0.19-1.54,1.21,1.79 c0.79,2.58,2.88,4.54,4.73,4.06C666.68,223.04,666.72,223.19,666.77,223.34z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M663.43,239.89c-0.12,0.14-0.3,0.27-0.56,0.38c-1.66,0.75-6.09,0.78-10.46,0.55 c2.99-0.4,10.16-1.99,11.4-8.23C664.13,235.5,664.27,238.85,663.43,239.89z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M654.8,206.9c-0.39,0.47-1.04,0.67-2.13,0.42c-2.14-0.5-4.97,0.5-6.45,0.28c-0.77-0.11-1.26-0.34-1.56-0.52 c3.06-1.16,5.68-1.05,5.68-1.05C651.87,206.03,653.37,206.32,654.8,206.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M639.65,229.52c-0.75,0.99-1.74,2.27-2.75,3.55c-2.12-1.31-3.89-3.5-4.87-4.86c0.86-1.56,1.82-3.49,2.3-4.48 c0.58,0.86,1.52,2.01,2.46,3.07C637.95,228.12,639.12,229.27,639.65,229.52z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M639.65,229.52c-0.75,0.99-1.74,2.27-2.75,3.55c-0.38,0.48-0.77,0.96-1.14,1.42 c0.11-3.98-1.28-7.57-2.11-9.35c0.28-0.55,0.51-1.04,0.69-1.41c0.58,0.86,1.52,2.01,2.46,3.07 C637.95,228.12,639.12,229.27,639.65,229.52z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M632.76,226.85c-0.01,1.18-1.09,2.83-1.41,3.35c-0.38,0.59-0.07,3.18-0.42,2.88c-0.35-0.31-0.5-1.58-0.97-2 c-0.43-0.39-5.69-1.72-6.68-1.96c2.67,0.59,6.53,1.8,7.13,1.49c0.3-0.15,0.93-1.15,1.62-2.38 C632.27,227.78,632.52,227.31,632.76,226.85z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M654.49,202.29c-0.61,1.03-1.47,2.04-2.28,2.71c-0.63,0.51-1.24,0.82-1.71,0.75 c-1.54-0.22-3.46-2.71-3.5-3.18c-0.03-0.47,1.65-0.65,1.44-2.04c-0.22-1.38-1.1-1.64-1.76-1.38c-0.66,0.25-1.46,1.69-1.43,3.05 c-0.44-0.06-1.28-1.73-2.83-2.69c-0.43-0.26-0.91-0.48-1.46-0.58c0.84-0.11,1.79-0.14,2.43,0.13c1.42,0.59,1.47,1.16,1.47,1.16 s0.21-2.04,2.46-2.46C649.25,197.4,650.77,202.65,654.49,202.29z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M647.83,299.32h-15.01c0,0-0.15-0.47-0.15-1.07c-0.01-0.78,0.25-1.79,1.45-2.28 c0.42-0.17,0.88-0.38,1.36-0.6c1.88-0.89,3.91-2.07,4.24-2.75c0,0,0.11,0.05,0.3,0.14c0.38,0.17,1.08,0.46,1.77,0.64 c0.35,0.1,0.7,0.16,1.01,0.16c0.84,0.02,2.47-0.43,3.5-0.56c0.47-0.06,0.82-0.06,0.91,0.09c0.21,0.34,0.44,3.47,0.56,5.16 C647.8,298.89,647.83,299.32,647.83,299.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123408203122981310370000003351524896965377465_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.6472,
    y1: 299.186,
    x2: 644.4161,
    y2: 285.9078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D17878"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123408203122981310370000003351524896965377465_)"
    },
    d: "M646.72,290.79 c-0.12,0.69-0.28,1.54-0.43,2.21c-0.75,0.1-1.81,0.36-2.66,0.49c-0.32,0.05-0.61,0.08-0.84,0.07c-0.93-0.03-2.21-0.55-2.79-0.81 c-0.01-0.75,0.09-1.86,0.16-2.58l2.57,0.24L646.72,290.79z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M665.82,299.32h-9.06c0,0-0.16-0.42-0.14-1.07c0.01-0.42,0.1-0.94,0.36-1.51c0.66-1.45,0.31-3.81,0.62-4.25 c0,0,0.15-0.02,0.4-0.04c1.21-0.14,4.8-0.51,5.86-0.41c0.1,0.01,0.16,0.03,0.22,0.04c0.6,0.2,1.3,4.15,1.59,6.17 C665.76,298.77,665.81,299.16,665.82,299.32z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M647.76,298.25c0.04,0.64,0.07,1.07,0.07,1.07h-15.01c0,0-0.15-0.47-0.15-1.07H647.76z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M665.82,299.32h-9.06c0,0-0.16-0.42-0.14-1.07h9.06C665.76,298.77,665.81,299.16,665.82,299.32z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M641.78,293.4c-1.39,0.93-3.99,2.56-4.87,2.57c-0.64,0.01-1.12-0.3-1.44-0.6c1.88-0.89,3.91-2.07,4.24-2.75 c0,0,0.11,0.05,0.3,0.14C640.38,292.93,641.08,293.22,641.78,293.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M646.72,290.79c-0.12,0.69-0.28,1.54-0.43,2.21c-0.75,0.1-1.81,0.36-2.66,0.49l-0.88-3.07L646.72,290.79z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M663.87,288.28v3.77c-0.66-0.06-2.28,0.05-3.71,0.19l-1.02-3.22L663.87,288.28z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103224468176996898940000007660034055526523804_",
    gradientUnits: "userSpaceOnUse",
    x1: -1575.6893,
    y1: 282.7155,
    x2: -1756.1721,
    y2: 156.6042,
    gradientTransform: "matrix(-1 0 0 1 -1476.6877 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103224468176996898940000007660034055526523804_)"
    },
    d: "M151.84,227.19c0,0-2.76-9.97,3.07-16.24 c5.83-6.27,21.76-15.69,22.04-27.35c0.28-11.66,9.07-26.32,20.57-28.98c11.5-2.66,20.37-29.34,30.71-34.66 c10.35-5.33,25.1-5.78,29.37-12.52c4.26-6.75,54.07,90,51.61,99.94c-2.46,9.94-46.83-2.84-58.73,0.08 c-11.9,2.92-17.51,10.09-30.74,11.89c-13.23,1.8-32.88-1.4-39.78,2.49c-6.89,3.89-19.58,9.63-25.78,7.26 C151.67,228.15,151.84,227.19,151.84,227.19z"
  }), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M154.26,229.09l-2.81-2.83c-0.4-0.4-1.09-0.22-1.24,0.33l-0.68,2.53l-6.05,6.02c-0.27,0.27-0.27,0.7,0,0.97 l0.9,0.91c0.27,0.27,0.7,0.27,0.97,0l6.05-6.02l2.53-0.67C154.47,230.18,154.66,229.49,154.26,229.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145047207319646940330000009271112846525251260_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.0155,
    y1: 199.6409,
    x2: 119.8129,
    y2: 211.7863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D17878"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145047207319646940330000009271112846525251260_)"
    },
    d: "M125.03,199.05c0,0-0.06,1.12-0.25,2.54 c-0.24,1.83-0.7,4.17-1.51,5.35c-0.03,0.04-0.05,0.08-0.08,0.12c-1.21,1.6-3.53,1.21-4.7-0.78c0.7-0.86,1-1.96,0.53-2.4 c-0.96-0.91-0.7-3.49,0.68-3.18c1.38,0.32,1.6,4.03,2.11,3.94C122.19,204.57,124.18,201.33,125.03,199.05z"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M125.41,197.46c0,0.4-0.15,0.96-0.38,1.59c-0.14,0.37-0.31,0.77-0.49,1.18c-0.96,2.08-2.42,4.35-2.74,4.42 c-0.5,0.1-0.73-3.62-2.11-3.94c-1.38-0.31-1.64,2.27-0.68,3.18c0.47,0.44,0.16,1.54-0.53,2.4c-0.75,0.93-1.95,1.58-3.16,0.84 c-2.33-1.41-2.73-10.28-2.71-10.98c0,0-0.05-0.58,0.14-1.36c0.27-1.09,1.01-2.56,3-3.43 C119.18,189.89,125.41,190.2,125.41,197.46z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M143.43,234.49c-0.02,0.1-0.04,0.18-0.06,0.26c-0.11,0.4-0.23,0.68-0.37,0.73 c-0.14,0.05-0.83-0.02-1.82-0.14c-1.39-0.18-3.38-0.5-5.25-0.85c-2.24-0.43-4.31-0.91-5.01-1.27c-0.62-0.32-1.51-1.51-2.41-2.89 c-0.23-0.37-0.47-0.74-0.7-1.12c-1.11-1.82-2.08-3.67-2.33-4.16c-0.05-0.08-0.07-0.13-0.07-0.13s0,0.04-0.01,0.13 c-0.03,0.49-0.19,2.33-0.81,4.16c-0.13,0.38-0.28,0.76-0.46,1.12c-0.15,0.33-0.33,0.65-0.52,0.94c-0.59,0.92-0.47,2.07-0.08,3.22 c0.05,0.14,0.1,0.28,0.15,0.42l0.01,0.01c0.09,0.23,0.19,0.47,0.29,0.69c0.17,0.41,0.37,0.8,0.55,1.18 c0.55,1.14,1.03,2.13,0.87,2.72c-0.02,0.08-0.08,0.17-0.19,0.26c-0.07,0.07-0.15,0.14-0.26,0.21c-0.39,0.28-1,0.59-1.78,0.91 c-4.47,1.86-14.46,4-18.81,0c-0.07-0.06-0.15-0.13-0.22-0.21c-0.02-0.02-0.03-0.03-0.05-0.05c-0.28-0.29-0.39-0.57-0.38-0.87 c0.01-0.41,0.23-0.84,0.56-1.35c0.5-0.75,1.24-1.65,1.85-2.82c0.19-0.35,0.35-0.72,0.5-1.12c0.23-0.61,0.41-1.28,0.5-2.02 c0.09-0.73,0.16-1.44,0.21-2.14c0.03-0.38,0.06-0.75,0.07-1.12c0.08-1.45,0.1-2.84,0.08-4.16c-0.01-0.38-0.01-0.75-0.03-1.12 c-0.03-1.48-0.1-2.87-0.15-4.16c-0.02-0.38-0.03-0.76-0.04-1.12c-0.05-1.53-0.05-2.91,0.08-4.16c0.04-0.39,0.1-0.76,0.17-1.12 c0.32-1.68,0.97-3.08,2.23-4.17c0.05-0.04,0.09-0.08,0.14-0.12c0.45-0.37,0.88-0.7,1.29-1c0.47-0.34,0.91-0.62,1.31-0.87 c2.7-1.63,4.07-1.39,4.07-1.39s0.83,0.05,2.07,0.26c1.2,0.21,2.8,0.57,4.39,1.19c0.19,0.07,0.38,0.15,0.57,0.23 c0.41,0.17,0.81,0.37,1.2,0.58c0.27,0.14,0.53,0.29,0.78,0.45c0.32,0.21,0.64,0.43,0.94,0.67c0.75,0.59,1.4,1.28,1.9,2.1 c0.38,0.62,0.75,1.32,1.13,2.07c0.18,0.36,0.36,0.74,0.55,1.12c0.61,1.32,1.21,2.75,1.77,4.16c0.15,0.38,0.3,0.75,0.43,1.12 c0.58,1.5,1.09,2.93,1.52,4.16c0.13,0.4,0.26,0.77,0.38,1.12c0.41,1.21,0.69,2.1,0.81,2.45c0.15,0.47,1.12,0.91,2.36,1.32 c0.4,0.14,0.84,0.26,1.28,0.39c0.86,0.24,1.75,0.47,2.53,0.68c0.6,0.16,1.14,0.31,1.55,0.44c0.43,0.14,0.72,0.26,0.78,0.38 c0.03,0.04,0.05,0.1,0.07,0.17C143.75,231.54,143.67,233.34,143.43,234.49z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M124.74,208.29c0.38,0.2,0.74,0.42,1.08,0.65h-15.41c0.3-0.24,0.59-0.46,0.86-0.65H124.74 M124.8,208.06 h-13.61c-0.41,0.29-0.84,0.62-1.29,1c-0.05,0.04-0.09,0.08-0.14,0.12h16.75C125.98,208.75,125.41,208.38,124.8,208.06 L124.8,208.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M129.4,213.57c0.11,0.21,0.21,0.43,0.32,0.66h-22.1c0.03-0.24,0.06-0.46,0.1-0.66H129.4 M129.55,213.34 h-22.01c-0.07,0.36-0.13,0.74-0.17,1.12h22.73C129.91,214.08,129.73,213.7,129.55,213.34L129.55,213.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M131.71,218.86c0.09,0.22,0.17,0.44,0.26,0.66h-24.42c-0.01-0.22-0.01-0.43-0.02-0.66H131.71  M131.87,218.63h-24.58c0.01,0.37,0.02,0.74,0.04,1.12h24.98C132.16,219.38,132.02,219,131.87,218.63L131.87,218.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M133.66,224.15c0.05,0.15,0.1,0.3,0.15,0.45l0.07,0.21h-26.15c0-0.22-0.01-0.44-0.01-0.66H133.66  M133.82,223.91h-26.35c0.02,0.37,0.02,0.74,0.03,1.12h26.7C134.09,224.69,133.95,224.31,133.82,223.91L133.82,223.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M124.26,229.43c-0.09,0.24-0.18,0.46-0.27,0.66h-16.4c0.02-0.22,0.03-0.44,0.04-0.66H124.26 M124.6,229.2 h-17.18c-0.02,0.37-0.04,0.74-0.07,1.12h16.8C124.31,229.96,124.46,229.58,124.6,229.2L124.6,229.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M138.61,229.43c0.66,0.19,1.35,0.37,1.98,0.53l0.48,0.13h-12.44c-0.14-0.22-0.28-0.44-0.41-0.66H138.61  M138.64,229.2h-10.83c0.23,0.38,0.47,0.76,0.7,1.12h14.22c-0.41-0.13-0.95-0.29-1.55-0.44 C140.39,229.67,139.5,229.44,138.64,229.2L138.64,229.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M123.38,234.72c0.02,0.06,0.04,0.12,0.07,0.18l0.03,0.09c0,0.01,0.01,0.02,0.02,0.03 c0.05,0.12,0.09,0.24,0.14,0.35h-17.13c0.1-0.22,0.2-0.44,0.29-0.66H123.38 M123.54,234.49h-16.91 c-0.15,0.4-0.32,0.77-0.5,1.12h17.86c-0.11-0.23-0.2-0.46-0.29-0.69l-0.01-0.01C123.64,234.77,123.59,234.63,123.54,234.49 L123.54,234.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M143.14,234.72c-0.12,0.46-0.22,0.54-0.21,0.54c-0.01,0-0.03,0.01-0.1,0.01c-0.26,0-0.8-0.05-1.61-0.16 c-0.77-0.1-1.68-0.24-2.63-0.39H143.14 M142.93,235.26L142.93,235.26L142.93,235.26 M143.43,234.49h-7.5 c1.87,0.35,3.86,0.67,5.25,0.85c0.77,0.1,1.35,0.16,1.64,0.16c0.08,0,0.14-0.01,0.17-0.02c0.14-0.05,0.26-0.33,0.37-0.73 C143.39,234.67,143.41,234.58,143.43,234.49L143.43,234.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M124.51,240c-0.35,0.21-0.82,0.43-1.37,0.66h-18.67c-0.05-0.04-0.1-0.09-0.15-0.14l-0.16,0.16l0.12-0.21 c-0.15-0.16-0.25-0.31-0.29-0.48H124.51 M125.23,239.77h-21.5c-0.01,0.3,0.11,0.58,0.38,0.87c0.02,0.02,0.03,0.03,0.05,0.05 c0.07,0.07,0.15,0.14,0.22,0.21h18.81c0.78-0.32,1.39-0.64,1.78-0.91C125.07,239.91,125.16,239.84,125.23,239.77L125.23,239.77 z"
  })))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M126.86,289.29c-0.07,0.21-0.16,0.4-0.27,0.58c-1.26,2.16-4.69,2.37-5.96,1.96 c-0.17-0.05-0.3-0.11-0.38-0.19c-0.76-0.66-1.41-6.14-5.48-37.19c0,0.08,0,0.16-0.01,0.24v0.03c-0.07,4.41-1,12.25-1.98,19.48 c-1.07,7.96-2.21,15.19-2.36,16.32c-0.05,0.37-0.22,0.71-0.47,1c-1.14,1.3-4.01,1.62-5.71-0.44c-0.14-0.17-0.26-0.35-0.39-0.55 c0.7-5.66,1-23.32-0.14-33.79c-0.43-3.94-0.44-7.33-0.29-10.02c0.15-2.81,0.49-4.86,0.72-6.01c4.3,4.36,14.87,2.01,19.28,0.1 c0.66-0.29,1.18-0.56,1.53-0.81C126.19,244.97,125.72,259.71,126.86,289.29z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.59,207.48c-7.3,0.23-9.39,11.58-9.39,11.58l-1.71-11.87c2.7-1.63,4.07-1.39,4.07-1.39 S120.2,206.03,123.59,207.48z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M135.2,299.23c0,0-12.4,0-14.54,0c-0.06-0.4-0.08-1.03-0.1-1.76c-0.01-0.25-0.01-0.51-0.01-0.78 c-0.02-1.73,0.04-3.76,0.08-4.85c0.34,0.11,0.84,0.17,1.4,0.17c1.13-0.01,2.55-0.3,3.59-1.08c0.39-0.28,0.72-0.63,0.97-1.06 c0.88,1.92,2.72,3.22,4.44,4.16c1.52,0.83,2.94,1.38,3.53,1.81c0.56,0.4,0.77,1.03,0.82,1.64 C135.47,298.37,135.2,299.23,135.2,299.23z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M110.14,297.47c-0.04,1.1-0.12,1.76-0.12,1.76h-8.31c0.11-0.6,0.23-1.19,0.38-1.76 c0.7-2.88,1.71-5.37,2.16-6.4c0.54,0.66,1.2,1.08,1.89,1.3c0.81,0.25,1.64,0.24,2.36,0.03c0.59-0.17,1.11-0.48,1.46-0.88 C110.22,293.9,110.2,296.05,110.14,297.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027590362715833159110000006366945938709975453_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.67,
    y1: 230.6326,
    x2: 141.9266,
    y2: 234.2668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D17878"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027590362715833159110000006366945938709975453_)"
    },
    d: "M151.18,232.55 c-0.16,0.92-3.43,3.78-4.41,3.5c-0.16-0.05-0.33-0.12-0.49-0.21c-0.69-0.38-1.44-1.01-2.91-1.09c0.28-1.11,0.39-3.16,0.2-3.88 c0.19-0.09,0.4-0.19,0.65-0.3c1.09-0.49,2.62-1.11,3.25-1.01C148.51,229.72,151.34,231.64,151.18,232.55z"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M125.41,239.51c-0.04,0.13-0.19,0.3-0.44,0.48c-2.62,1.86-15.87,5.72-20.81,0.7 c-0.02-0.02-0.03-0.03-0.05-0.05c-0.65-0.67-0.4-1.35,0.17-2.21c0.72,0.57,1.99,1.19,4.23,1.56c4.41,0.72,12.24-0.47,16.03-3.19 C125.09,237.93,125.57,238.92,125.41,239.51z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143.37,234.75c-0.11,0.4-0.23,0.68-0.37,0.73c-0.14,0.05-0.83-0.02-1.82-0.14 c0.68-2.62,0.28-4.57-0.01-5.46c1.24,0.33,2.2,0.61,2.33,0.82c0.03,0.04,0.05,0.1,0.07,0.17 C143.76,231.59,143.65,233.64,143.37,234.75z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.69,234.91c-1.68-1.65-0.96-2.96,0-6.22c0.96-3.27-0.96-4.66-1.27-8.31c-0.32-3.65,0.06-5.73,2.33-8.12 c-2.71,7.11,0.66,12.65,0.66,12.65s-0.15,3.84-1.79,6.36C122.95,232.3,123.2,233.61,123.69,234.91z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M124.54,200.23c-0.96,2.08-2.42,4.35-2.74,4.42c-0.5,0.1-0.73-3.62-2.11-3.94 c-1.38-0.31-1.64,2.27-0.68,3.18c0.47,0.44,0.16,1.54-0.53,2.4c-0.75,0.93-1.95,1.58-3.16,0.84c-2.33-1.41-2.73-10.28-2.71-10.98 c0,0-0.05-0.58,0.14-1.36c1.15-0.06,3.72,0.09,4.34,2.41c0.59,2.24,0.59,3.34,0.55,3.76c0.12-0.65,0.67-2.59,2.8-2.16 C121.73,199.07,123.16,199.97,124.54,200.23z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M115.11,197.11c0,0-0.94-1.98-3.96-1.42c-3.02,0.57-4.39,4.44-3.02,10.71c0.05-5.57,0.85-6.84,0.85-6.84 s-1.27,3.4,0.38,11.04c1.65,7.65,2.6,15.06-1.51,18.31c8.17-4.63,8.64-10.06,8.17-16.66C115.53,205.65,117,199.85,115.11,197.11z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.01,203.83c-0.06,0.47,1.54,2.68,3.25,3.11c-0.03,0.04-0.05,0.08-0.08,0.12 c-0.05,0.06-0.1,0.12-0.15,0.18c-1.59-0.61-3.18-0.97-4.39-1.19c0.58-0.82,0.79-1.77,0.37-2.17c-0.96-0.91-0.7-3.49,0.68-3.18 c1.38,0.32,1.6,4.03,2.11,3.94c0.39-0.07,2.39-3.31,3.24-5.59c0,0-0.06,1.12-0.25,2.54c-0.46,0.84-1.46,2.56-2.24,3.23 c-1.04,0.9-1.44-0.21-1.72-0.9C120.53,203.25,120.09,203.29,120.01,203.83z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M105.81,246.58c0,0-0.23,4.27,0.31,5.42c0.54,1.15,2.23,1.95,2.23,1.95s2.09-0.88,2.63-2.14 c0.61-2.54,0.48-5.56,0.48-5.56S107.29,245.17,105.81,246.58z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M123.7,243.16c0,0,0.17,3.52-2.85,5.28"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 122.98,
    y1: 246.19,
    x2: 125.41,
    y2: 288.53
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.77,254.69v0.03c-0.07,4.41-1,12.25-1.98,19.48c-0.14-8.43-1.33-18.89-0.94-20.59 C113.1,254.81,114.77,254.69,114.77,254.69z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 112.5,
    y1: 255.78,
    x2: 109.02,
    y2: 290.32
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.44,240.79c-2.06,2.02-8.44,7.04-20,5.91c0.15-2.81,0.49-4.86,0.72-6.01 C108.45,245.05,119.03,242.7,123.44,240.79z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M102.1,297.47h8.05c-0.04,1.1-0.12,1.76-0.12,1.76h-8.31C101.83,298.63,101.95,298.04,102.1,297.47z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M135.2,299.23c0,0-12.4,0-14.54,0c-0.06-0.4-0.08-1.03-0.1-1.76h14.83 C135.47,298.37,135.2,299.23,135.2,299.23z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M131.04,294.03C131.04,294.03,131.04,294.03,131.04,294.03c-2.62,1.28-4.5-1.35-5.41-3.1 c0.39-0.28,0.72-0.63,0.97-1.06C127.48,291.79,129.32,293.09,131.04,294.03z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.5,292.39c-0.28,3.85-1.61,3.99-2.31,3.6c-0.64-0.36-0.21-2.83-0.05-3.63 C106.95,292.62,107.78,292.6,108.5,292.39z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.56,296.68c-0.02-1.73,0.04-3.76,0.08-4.85c0.34,0.11,0.84,0.17,1.4,0.17 C122.21,293.25,122.35,296.1,120.56,296.68z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143.37,234.75c0.28-1.11,0.39-3.16,0.2-3.88c0.19-0.09,0.4-0.19,0.65-0.3c0.73,1,1.93,2.97,2.07,5.26 C145.6,235.46,144.84,234.83,143.37,234.75z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M137.37,228.81c-2.32,0.23-3.84,2.62-4.04,2.14c-0.23-0.57,1.04-1.75,0.88-2.5 c-0.16-0.75-3.66-9.82-5.6-14.25c-1.18-2.69-2.31-4.6-3.02-5.69c0.32,0.21,0.64,0.43,0.94,0.67c0.75,0.59,1.4,1.28,1.9,2.1 c0.38,0.62,0.75,1.32,1.13,2.07c0.18,0.36,0.36,0.74,0.55,1.12c0.61,1.32,1.21,2.75,1.77,4.16c0.15,0.38,0.3,0.75,0.43,1.12 c0.58,1.5,1.09,2.93,1.52,4.16c0.13,0.4,0.26,0.77,0.38,1.12c0.41,1.21,0.69,2.1,0.81,2.45 C135.16,227.96,136.13,228.4,137.37,228.81z"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M689.55,301.56c-0.76-0.57-24.54-64.76,2.83-101.38c-3.78,25.86-1.7,47.01-1.7,47.01l-3.59,3.59l3.96,1.13 c0,0,2.67,35.9,3.96,40.05c-2.91-26.83,4.29-42.5,4.29-42.5s-1.27,19.04,1.18,26.04l-1.89,2.53l1.89-0.39c0,0-1.32,11.52,0,14.98 c0,0,15.29-45.71,8.12-65.77c9.44,14.67,6.8,39.16,6.8,39.16l-2.45,0.97l1.51,1.1c0,0-3.96,26.12-13.03,33.48"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M529.27,293.99c0,0-21.2-1.92-29.72,4.03c4.03-5.72,20.09-8.38,20.09-8.38l1.19,0.9l0-0.89c0,0,2.73-1.41,6.73-1.94 c-19.33-3.82-28.56-0.14-28.56-0.14s3.57-2.94,9.48-4.67c5.9-1.72,9.61-1.05,9.61-1.05l2.35,1.44l0.01-1.55l20.54,6.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M610.89,295.14c0,0-2.26-14.35,9.44-24.29C620.2,282.43,616.96,292.37,610.89,295.14z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M532.01,285.69l-2.3,5.57c-1.55-5.61-5.18-6.7-7-6.87c-0.66-0.07-1.08-0.02-1.08-0.02l0.85-2.74l-2.64,0.46 c0,0-3.02-7.25-16.33-16.03c12.25-0.69,19.78,5.7,23.99,11.38C530.71,281.77,532.01,285.69,532.01,285.69z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M503.5,266.06c11.32,3.07,23.41,9.34,27.88,20.87c0.11,0.28-0.34,0.46-0.44,0.15 C526.64,275.6,514.69,269.26,503.5,266.06L503.5,266.06z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M532.01,285.69l-2.3,5.57c-1.55-5.61-5.18-6.7-7-6.87c3.15-1.95,4.34-4.98,4.79-6.95 C530.71,281.77,532.01,285.69,532.01,285.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M620.33,259.01c-21.9,18-27.56,26.94-27.56,26.94l-3.9-1.7c0,0,0.01,0.12,0.01,0.33 c0.03,0.97,0.1,3.81-0.01,4.75c-0.08,0.82-7.89,5.02-12.34,7.35c-1.78,0.93-3.02,1.57-3.02,1.57l-3.65-3.66l0.37-0.72l1.9-3.7 c0,0,4.99-7.2,13.54-14.69C594.17,268.03,606.2,260.27,620.33,259.01z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M572.09,296.9c11.25-15.8,28.39-34.33,48.24-37.88c-15.62,2.94-28.01,14.28-38.27,25.77 c-3.42,3.94-6.66,8.05-9.58,12.37C572.32,297.41,571.91,297.16,572.09,296.9L572.09,296.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M588.86,289.34c-0.08,0.82-7.89,5.02-12.34,7.35c-2.43-0.91-4.64-1.95-6.3-2.81l1.9-3.7 c0,0,4.99-7.2,13.54-14.69c0.51,2.65,1.48,6.35,3.2,9.09C588.9,285.56,588.96,288.4,588.86,289.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M606.54,247.19c-15.67,13.03-22.84,23.94-25.8,29.51c-1.36,2.55-1.83,3.97-1.83,3.97l-3.4-1.26l1.39,3.14 l-4.98,10.07v0.01l-2.18,4.41v-17.55c0.67-1.29,1.58-2.99,2.76-4.93c2.2-3.64,5.28-8.15,9.21-12.47 c1.78-1.96,3.74-3.89,5.87-5.67C592.88,251.97,599.22,248.38,606.54,247.19z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M569.53,286.47c6.02-15.58,17.15-29.68,32.23-37.23c1.07-0.46,3.7-1.58,4.78-2.05 c-1.1,0.48-3.71,1.63-4.76,2.09c-10.84,5.5-19.61,14.54-25.81,24.91c-2.36,3.96-4.44,8.11-6,12.43c-0.04,0.13-0.18,0.2-0.3,0.15 C569.55,286.73,569.48,286.59,569.53,286.47L569.53,286.47z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M578.92,280.67l-3.4-1.26l1.39,3.14l-4.98,10.07v0.01l-2.18,0.31v-13.45c0.67-1.29,1.58-2.99,2.76-4.93 c1.55,1.27,4.29,2.75,8.24,2.14C579.39,279.24,578.92,280.67,578.92,280.67z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M626.49,299.32h-56.74v-7.96c0,0,0.84-1.93,3.13-3.09c0.7-0.36,1.55-0.65,2.55-0.78 c4.25-0.57,5.66,2.92,5.66,2.92s1.04-3.03,5.29-3.41c4.12-0.36,6.64,6.07,6.79,6.46c-0.03-0.33-0.32-3.9,2.84-4.13 c3.3-0.24,3.3,4.15,3.3,4.15s2.64-2.87,6.04-2.69c3.4,0.19,4.15,3.5,4.15,3.5s1.89-2.83,6.04-1.84S620.17,299.32,626.49,299.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M608.77,299.32h-39.02v-7.96c0,0,0.84-1.93,3.13-3.09c1.7,0.13,4.7,0.68,5.95,2.99 c1.8,3.31,1.92,6.42,1.92,6.42s3.81-5.46,6.84-4.52c3.03,0.94,4.64,4.52,4.64,4.52s3.2-3.4,5.9-2.26 C599.48,296,604.3,297.73,608.77,299.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M496.77,301.56c-0.21-0.16-6.9-18.21,0.8-28.51c-1.06,7.27-0.48,13.22-0.48,13.22l-1.01,1.01l1.11,0.32 c0,0,0.75,10.09,1.11,11.26c-0.82-7.54,1.21-11.95,1.21-11.95s-0.36,5.35,0.33,7.32l-0.53,0.71l0.53-0.11c0,0-0.37,3.24,0,4.21 c0,0,4.3-12.85,2.28-18.49c2.65,4.13,1.91,11.01,1.91,11.01l-0.69,0.27l0.42,0.31c0,0-1.11,7.34-3.66,9.41"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.73,295.69c0,0-33.44-22.56-53.02-20.47c11.92-5.81,41.01,4.45,41.01,4.45l1.15,2.57l0.82-1.47 c0,0,5.81,0.15,12.94,2.93c-28.6-24.01-47.28-26.33-47.28-26.33s8.62-1.62,20,0.91c11.38,2.53,16.92,7.04,16.92,7.04l2.58,4.53 l1.43-2.56l28.59,28.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M211.68,298.35c0,0-14.12-3.02-22.99-13.59C203.79,286.27,210.32,291.74,211.68,298.35z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M258.91,234.75c-1.21,28.32,1.67,38.5,1.67,38.5l-3.87,1.77c0,0,0.09,0.08,0.26,0.21 c0.74,0.63,2.9,2.47,3.53,3.18c0.55,0.61-1.53,9.23-2.76,14.09c-0.49,1.95-0.85,3.29-0.85,3.29l-5.16,0.28l-0.29-0.75l-1.49-3.88 c0,0-2.03-8.52-1.9-19.89C248.18,260.25,250.42,246.11,258.91,234.75z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M254.95,295.96c-4.27-18.95-6.63-44.02,3.97-61.21c-8.23,13.6-8.05,30.39-6.34,45.7 c0.65,5.18,1.55,10.34,2.82,15.39C255.48,296.12,255.02,296.27,254.95,295.96L254.95,295.96z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M260.5,278.42c0.55,0.61-1.53,9.23-2.76,14.09c-2.29,1.2-4.55,2.15-6.3,2.82l-1.49-3.88 c0,0-2.03-8.52-1.9-19.89c2.32,1.39,5.72,3.13,8.91,3.68C257.72,275.87,259.87,277.71,260.5,278.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M278.89,254.26c-7,12.21-9.01,20.99-9.58,25.31c-0.26,1.97-0.22,3.01-0.22,3.01l-2.5,0l1.65,1.7l-0.79,7.71 l0,0l-0.35,3.38l-4.23-11.35c0.12-1,0.3-2.31,0.6-3.85c0.54-2.89,1.45-6.55,2.95-10.29c0.68-1.7,1.48-3.42,2.43-5.08 C271.2,260.64,274.44,256.8,278.89,254.26z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M264.34,288.59c0.16-11.54,3.98-23.35,11.94-31.86c0.58-0.55,2.01-1.91,2.6-2.47c0,0-1.71,1.67-1.71,1.67 c-6.24,6.18-9.91,14.62-11.5,23.18c-0.57,3.13-0.9,6.32-0.87,9.49C264.82,288.88,264.34,288.9,264.34,288.59L264.34,288.59z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M269.09,282.57l-2.5,0l1.65,1.7l-0.79,7.71l0,0l-1.33,0.73l-3.24-8.7c0.12-1,0.3-2.31,0.6-3.85 c1.31,0.44,3.44,0.74,5.84-0.6C269.05,281.54,269.09,282.57,269.09,282.57z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M302.91,299.23l-14.19,0.02l-61.68,0.06l-18.33,0.02c0,0,1.51-4.94,8.69-7.2c7.17-2.27,9.25,2.43,9.25,2.43 s-0.39-9.39,8.12-12.61c8.5-3.22,12.27,7.54,12.27,7.54s1.69-5.31,10.76-5.76c9.06-0.46,8.12,6.62,8.12,6.62s5.1-5.73,14.35-4.42 c9.25,1.3,10.2,8.64,10.2,8.64S298.56,292.18,302.91,299.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M288.71,299.24l-61.68,0.06c3.19-2.84,8.4-6.53,13.95-6.58c9.06-0.1,10.52,3.18,10.52,3.18 s5.59-5.92,9.99-4.92c4.41,1.01,4.6,5.73,4.6,5.73S280.17,293.45,288.71,299.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.1,303.18c0,0-10.26-18.15-7.17-35.78c3.02,13.77,10.38,22.93,10.38,22.93l-3.02,2.39h3.02l6.42,12.24 l-8.69-1.78v0.83L313.1,303.18z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st42",
    d: "M385.1,411.35c-0.43,0.44-0.8,0.93-1.11,1.45l-0.47-0.24c-0.07-0.3-0.35-0.5-0.66-0.47 c-0.33,0.04-0.57,0.34-0.53,0.67c0.04,0.33,0.34,0.57,0.67,0.53c0.07-0.01,0.13-0.03,0.18-0.05l0.45,0.23 c-0.25,0.55-0.43,1.14-0.54,1.74l0.75,0.13c0.23-1.31,0.85-2.51,1.79-3.47L385.1,411.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st42",
    d: "M390.59,409.05c-0.17,0-0.34,0.01-0.51,0.02l-0.07-0.63c0.19-0.15,0.3-0.39,0.27-0.64 c-0.05-0.39-0.4-0.67-0.8-0.63c-0.39,0.05-0.67,0.4-0.63,0.8c0.03,0.25,0.19,0.46,0.4,0.56l0.07,0.62 c-0.71,0.12-1.4,0.33-2.06,0.65l0.33,0.68c0.93-0.45,1.94-0.67,3-0.67c0.5,0,0.99,0.05,1.47,0.16l0.16-0.74 C391.69,409.1,391.14,409.05,390.59,409.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st42",
    d: "M397.19,411.59c0.33-0.04,0.57-0.34,0.53-0.67c-0.04-0.33-0.34-0.57-0.67-0.53 c-0.31,0.04-0.54,0.3-0.53,0.61l-0.42,0.36c-0.42-0.43-0.89-0.81-1.41-1.14l-0.4,0.64c1.13,0.71,2.02,1.73,2.56,2.93l0.69-0.31 c-0.25-0.55-0.57-1.07-0.94-1.54l0.4-0.35C397.06,411.6,397.13,411.6,397.19,411.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st42",
    d: "M390.04,419.25c-0.39,0.02-0.77,0.03-1.16,0.03c-0.88,0-1.73-0.06-2.48-0.18 c-0.39-0.06-0.85-0.15-1.27-0.29c1.05,1.86,3.07,3.12,5.39,3.12c2.86,0,5.26-1.92,5.95-4.5c-0.68,0.45-1.51,0.83-2.46,1.12 C392.84,418.93,391.46,419.17,390.04,419.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st42",
    d: "M390.59,410.56c-3.35,0-6.08,2.67-6.08,5.94c0,0.43,0.05,0.85,0.14,1.26 c0.67,0.48,2.71,0.89,5.35,0.73c2.88-0.17,5.3-0.96,6.67-2.16c-0.01-0.2-0.02-0.39-0.05-0.58 C396.24,412.79,393.65,410.56,390.59,410.56z M388.43,417.08c-1.02,0-1.85-0.83-1.85-1.85c0-1.02,0.83-1.85,1.85-1.85 c1.02,0,1.85,0.83,1.85,1.85C390.28,416.25,389.45,417.08,388.43,417.08z M393.17,416.17c-0.75,0-1.36-0.61-1.36-1.36 c0-0.75,0.61-1.36,1.36-1.36c0.75,0,1.36,0.61,1.36,1.36C394.53,415.56,393.92,416.17,393.17,416.17z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st42",
    d: "M406.6,412.43c-0.29-0.12-0.81-0.31-1.38-0.24c-0.55,0.07-0.84,0.34-0.84,1.01v0.87h2.23 v1.72h-2.23v5.45h-1.93v-5.45h-1.34v-1.72h1.34v-0.89c0-1.68,0.9-2.78,2.57-2.78c0.64,0,1.16,0.12,1.59,0.31L406.6,412.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st42",
    d: "M411.3,415.76c-0.18-0.03-0.36-0.05-0.53-0.05c-0.9,0-1.51,0.55-1.51,1.61v3.91h-1.93v-7.17 h1.87v0.78c0.45-0.67,1.14-0.98,2.02-0.98c0.41,0,0.85,0.13,1.09,0.34L411.3,415.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st42",
    d: "M418.97,417.64c0,0.22-0.01,0.49-0.04,0.65h-5.08c0.21,1.04,0.93,1.49,1.84,1.49 c0.62,0,1.3-0.25,1.81-0.69l1.13,1.24c-0.81,0.75-1.85,1.09-3.06,1.09c-2.2,0-3.72-1.5-3.72-3.75c0-2.26,1.48-3.8,3.63-3.8 C417.54,413.87,418.96,415.4,418.97,417.64z M413.85,416.97h3.18c-0.18-0.92-0.73-1.44-1.56-1.44 C414.55,415.54,414.02,416.08,413.85,416.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st42",
    d: "M426.62,417.64c0,0.22-0.01,0.49-0.04,0.65h-5.08c0.21,1.04,0.93,1.49,1.84,1.49 c0.62,0,1.3-0.25,1.81-0.69l1.13,1.24c-0.81,0.75-1.85,1.09-3.06,1.09c-2.2,0-3.72-1.5-3.72-3.75c0-2.26,1.48-3.8,3.63-3.8 C425.2,413.87,426.61,415.4,426.62,417.64z M421.5,416.97h3.18c-0.18-0.92-0.73-1.44-1.56-1.44 C422.21,415.54,421.67,416.08,421.5,416.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st42",
    d: "M434.96,417.65c0,2.15-1.49,3.77-3.47,3.77c-0.96,0-1.64-0.38-2.11-0.93v3.71h-1.92v-10.13 h1.89v0.79c0.47-0.58,1.15-0.98,2.14-0.98C433.47,413.87,434.96,415.49,434.96,417.65z M429.29,417.65 c0,1.13,0.75,1.98,1.84,1.98c1.14,0,1.85-0.88,1.85-1.98c0-1.1-0.71-1.98-1.85-1.98C430.03,415.67,429.29,416.51,429.29,417.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st42",
    d: "M438.07,411.72c0,0.7-0.54,1.23-1.24,1.23c-0.7,0-1.23-0.53-1.23-1.23 c0-0.7,0.53-1.24,1.23-1.24C437.53,410.47,438.07,411.02,438.07,411.72z M437.81,421.24h-1.93v-7.17h1.93V421.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st42",
    d: "M441.03,416.62l2.7-2.55h2.37l-3.48,3.38l3.5,3.8h-2.38l-2.72-2.9v2.9h-1.93v-10.66h1.93 V416.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M309.41,421.17v-1.05c-0.53,0.72-1.39,1.23-2.39,1.23c-1.85,0-3.15-1.41-3.15-3.71 c0-2.26,1.29-3.72,3.15-3.72c0.95,0,1.82,0.47,2.39,1.25v-3.76h1.1v9.77H309.41z M309.41,419.25v-3.21 c-0.4-0.62-1.24-1.14-2.12-1.14c-1.42,0-2.27,1.17-2.27,2.74c0,1.57,0.85,2.72,2.27,2.72 C308.17,420.37,309.02,419.87,309.41,419.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M311.93,417.63c0-2.05,1.46-3.71,3.49-3.71c2.14,0,3.4,1.67,3.4,3.79v0.28h-5.73 c0.09,1.33,1.03,2.45,2.55,2.45c0.81,0,1.63-0.32,2.18-0.89l0.53,0.72c-0.7,0.7-1.65,1.08-2.81,1.08 C313.44,421.35,311.93,419.84,311.93,417.63z M315.4,414.83c-1.51,0-2.26,1.27-2.31,2.36h4.64 C317.72,416.13,317.01,414.83,315.4,414.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M319.61,420.23l0.57-0.79c0.47,0.54,1.36,1.01,2.33,1.01c1.08,0,1.67-0.51,1.67-1.22 c0-1.71-4.38-0.66-4.38-3.28c0-1.1,0.95-2.04,2.64-2.04c1.2,0,2.05,0.45,2.62,1.03l-0.51,0.76c-0.42-0.51-1.2-0.89-2.11-0.89 c-0.97,0-1.57,0.48-1.57,1.11c0,1.55,4.38,0.53,4.38,3.28c0,1.19-0.95,2.14-2.78,2.14C321.31,421.35,320.32,420.99,319.61,420.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M326.48,412.35c0-0.41,0.34-0.75,0.73-0.75c0.41,0,0.75,0.34,0.75,0.75c0,0.41-0.34,0.73-0.75,0.73 C326.81,413.08,326.48,412.76,326.48,412.35z M326.67,421.17v-7.07h1.1v7.07H326.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M329.58,422.99l0.56-0.82c0.59,0.7,1.29,0.97,2.3,0.97c1.17,0,2.27-0.57,2.27-2.12V420 c-0.51,0.72-1.38,1.26-2.37,1.26c-1.85,0-3.15-1.38-3.15-3.66c0-2.27,1.29-3.68,3.15-3.68c0.95,0,1.8,0.47,2.37,1.25v-1.07h1.1 v6.87c0,2.34-1.64,3.08-3.37,3.08C331.24,424.04,330.42,423.81,329.58,422.99z M334.71,419.13v-3.09 c-0.38-0.62-1.23-1.14-2.11-1.14c-1.42,0-2.27,1.13-2.27,2.7c0,1.55,0.85,2.7,2.27,2.7 C333.48,420.29,334.33,419.75,334.71,419.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M342.41,421.17v-4.63c0-1.24-0.63-1.64-1.58-1.64c-0.86,0-1.68,0.53-2.09,1.1v5.17h-1.1v-7.07h1.1v1.03 c0.5-0.59,1.46-1.2,2.52-1.2c1.48,0,2.26,0.75,2.26,2.29v4.97H342.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M344.93,417.63c0-2.05,1.46-3.71,3.49-3.71c2.14,0,3.4,1.67,3.4,3.79v0.28h-5.73 c0.09,1.33,1.03,2.45,2.55,2.45c0.81,0,1.63-0.32,2.18-0.89l0.53,0.72c-0.7,0.7-1.66,1.08-2.81,1.08 C346.44,421.35,344.93,419.84,344.93,417.63z M348.4,414.83c-1.51,0-2.26,1.27-2.31,2.36h4.64 C350.72,416.13,350.02,414.83,348.4,414.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M358.35,421.17v-1.05c-0.53,0.72-1.39,1.23-2.39,1.23c-1.85,0-3.15-1.41-3.15-3.71 c0-2.26,1.29-3.72,3.15-3.72c0.95,0,1.82,0.47,2.39,1.25v-3.76h1.1v9.77H358.35z M358.35,419.25v-3.21 c-0.4-0.62-1.25-1.14-2.12-1.14c-1.42,0-2.27,1.17-2.27,2.74c0,1.57,0.85,2.72,2.27,2.72 C357.1,420.37,357.95,419.87,358.35,419.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M364.69,421.17v-9.77h1.1v3.76c0.57-0.78,1.42-1.25,2.39-1.25c1.85,0,3.15,1.46,3.15,3.72 c0,2.3-1.3,3.71-3.15,3.71c-1,0-1.86-0.51-2.39-1.23v1.05H364.69z M367.9,420.37c1.44,0,2.29-1.16,2.29-2.72 c0-1.57-0.85-2.74-2.29-2.74c-0.86,0-1.73,0.53-2.11,1.14v3.21C366.17,419.87,367.04,420.37,367.9,420.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M372.53,422.94c0.16,0.07,0.42,0.12,0.6,0.12c0.48,0,0.81-0.16,1.05-0.75l0.47-1.07l-2.96-7.15h1.19 l2.36,5.8l2.34-5.8h1.2l-3.54,8.51c-0.42,1.03-1.14,1.42-2.08,1.44c-0.23,0-0.6-0.04-0.81-0.1L372.53,422.94z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.abdd0afeece1f25d9f919f7e6d58335c.svg";
export { ForwardRef as ReactComponent };